export default __webpack_public_path__ + "static/media/3435 spice rack E side.be031d40.png";